import { injectIntl, IntlShape } from 'react-intl';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import moment from 'moment';
import { FunctionComponent, useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import { DialogActions, FormControl, TextField } from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import CardTitle from 'containers/common/Card/CardTitle';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerLegalProceedings/Provision/messages';

import currentUserStorage from 'containers/services/security/current-user-storage';

const DialogTitle = (props: any) => {
  const { children, classes, onClose } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton}>
          <CloseIcon onClick={onClose} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
};

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    width: '100%',
    height: '100%',
  },
}))(MuiDialogContent);
const DialogTitleStyled = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}))(DialogTitle);
const StyledDialog = styled(Dialog)`
  .MuiDialog-paperWidthSm {
    min-width: 900px;
  }
  .MuiFormControl-root {
    width: 800px;
  }
  .MuiDialogActions-root {
    flex: 0 0 auto;
    display: flex;
    padding: 8px;
    align-items: center;
    justify-content: space-between;
  }
`;
const ProvisionDialog: FunctionComponent<{
  intl: IntlShape;
  open: boolean;
  handleClose: any;
  title: string;
  confirmTitle: string;
  cancelTitle: string;
  requestValidateProvisionIntervenant?: Function;
  riskId: string;
  claimNumber?: string;
  setCurrentRisk: Function;
  setUpdateCurrentRisk: any;
  claimId: number;
}> = (props): JSX.Element => {
  const [amount, setAmount] = useState<any>(null);

  /* istanbul ignore next */
  const handleChangeProvision = (event: React.ChangeEvent<{ value: any }>) =>
    setAmount(event.target.value);

  /* istanbul ignore next */
  const successCallBack = () => {
    toast.success(
      translate(messages.editProvisionIntervenantSuccessMessage, props),
    );
    props.setUpdateCurrentRisk(true);
  };

  /* istanbul ignore next */
  const handleValidate = () => {
    props.setUpdateCurrentRisk(false);
    props.requestValidateProvisionIntervenant &&
      props.requestValidateProvisionIntervenant(
        {
          riskId: props.riskId,
          reasonCode: '7',
          date: moment().toISOString(true),
          typeProvision: 1,
          amount,
          claimNumber: props.claimNumber,
          claimId: props.claimId,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
          createdBy: currentUserStorage?.get()?.username,
          isManualEvaluation: true,
        },
        successCallBack,
      );
    props.handleClose();
  };
  return (
    <div>
      <StyledDialog
        onClose={/* istanbul ignore next */ () => props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitleStyled onClose={props.handleClose}>
          <div className="header">
            <CardTitle count={-1} message={props.title} />
          </div>
        </DialogTitleStyled>
        <DialogContent dividers>
          <FormControl>
            <div style={{ marginTop: '20px' }}>
              <TextField
                id="amount"
                label={translate(messages.provisionAmount, props)}
                onChange={handleChangeProvision}
                value={amount}
                fullWidth
              />
            </div>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <SecondaryButton
            data-testid="cancel"
            title={props.cancelTitle}
            onClick={props.handleClose}
          />
          <PrimaryButton
            data-testid="validate"
            background={'#0075C9'}
            titlecolor={'#FFFFFF'}
            border={'#0075C9'}
            title={props.confirmTitle}
            onClick={handleValidate}
            disabled={false}
          />
        </DialogActions>
      </StyledDialog>
    </div>
  );
};
export default injectIntl(ProvisionDialog);
